
import React, { useState, useEffect } from "react";
import {
    Form,
    Card,
    Button,
    Input,
    Steps,
    Upload,
    Select,
    DatePicker,
    message,
    Col,
    Row,
} from "antd";
import { UploadOutlined } from "@ant-design/icons";
import dayjs from "dayjs";
import { useParams, useNavigate } from "react-router-dom";
import {
    User_send_otp,
    User_verify_WO,
    UserRegUpdate,
    UserRegPost,
    UserDataPostwt,
    UserDataUpdatewl,
    User_StateGet,
    User_CasteGet,
} from "../../Api/CoreApi";
import { Spin } from "antd";
import LoginHeader from "../../Home_Page_WLog/LoginHeader/LoginHeader";

import { getRenderPropValue } from "antd/es/_util/getRenderPropValue";

const { Option } = Select;

function Registration_WO() {
    const Navigate = useNavigate();
    const admin_id = localStorage.getItem("ref");
    const reid = useParams();
    const ref = reid.id;
    // const ad_ref = admin_id
    // //console.log(admin_id, "************* ref *********");
    const user_id = localStorage.getItem("user_id");
    const [form] = Form.useForm();
    const [fileName, setFileName] = useState("");
    const [file, setFile] = useState(null); // Store file object
    const [phone_pop, setPhone_pop] = useState(0);
    const [user, setUser] = useState([]);
    const [data, setData] = useState([]);
    // const [ref, setRef] = useState([])

    const [district, setDistrict] = useState([]);
    const [state, setState] = useState([]);
    const [caste, setCaste] = useState([]);
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

    // //console.log(district, '****** district *********')
    // //console.log(state, '****** state *********')
    // //console.log(caste, '****** caste *********')


    // --- 1. ADD LOADING STATE ---
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 768);
        };
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    // //console.log(data, "****** data ******");

    const handleStateChange = async (value) => {
        //console.log(value, '******* value ***********')
        setState(value);
        const response = await User_StateGet();
        const filter = response.filter((i) => i.state === value);
        const datamap = filter.map((i) => i.district);
        setDistrict(datamap);
    };

    const generateHeightOptions = () => {
        const heights = [];
        for (let feet = 4; feet <= 8; feet++) {
            const maxInches = feet === 8 ? 0 : 11;
            for (let inches = 0; inches <= maxInches; inches++) {
                const totalCm = Math.round((feet * 30.48) + (inches * 2.54));
                heights.push(`${feet}'${inches}" (${totalCm} cm)`);
            }
        }
        return heights;
    };

    const handlereligionChange = async (value) => {
        //console.log(value, '******* value ***********')

        const response = await User_CasteGet();
        const filter = response.filter(
            (i) => i.religion === value && i.state === state
        );
        const mapcaste = filter.map((i) => i.caste);
        // //console.log(mapcaste,'****** caste res ********')

        setCaste(mapcaste.sort());
        // //console.log(response, "99999", mapcaste);
    };

    // --- 2. UPDATE THE 'send' FUNCTION ---
    const send = async (value) => {
        //console.log(value, '******* value *******')
        setIsLoading(true); // Start loader before API call
        const response = await User_verify_WO(value);


        try {
            const contact = response.contact;
            const user_id1 = response.user_id;
            const mail = { contact: contact };
            setData(mail);
            localStorage.setItem("user_id", user_id1);
            // //console.log(response, "********* response ******");

            setPhone_pop(2);
        } catch (error) {
            //console.error("OTP verification failed:", error);
            // Optional: show error message to user
        } finally {
            setIsLoading(false); // Stop loader in finally block to ensure it always runs
        }
    };

    // const verify = async (value) => {
    //   const response = await User_verify_WO(value);
    //   const email = response.email;
    //   const user_id1 = response.user_id;
    //   const mail = { email: email };
    //   setData(mail);
    //   localStorage.setItem("user_id", user_id1);
    //   //console.log(response, "********* response ******");
    //   setPhone_pop(2);
    // };
    //   const verify = async (value) => {
    //     setIsLoading(true); // Start loader before API call

    //     try {
    //       const response = await User_verify_WO(value);

    //       const contact = response.contact;
    //       const user_id1 = response.user_id;
    //       const mail = { contact: contact };
    //       setData(mail);
    //       localStorage.setItem("user_id", user_id1);
    //       // //console.log(response, "********* response ******");

    //       setPhone_pop(2);
    //     } catch (error) {
    //       //console.error("OTP verification failed:", error);
    //       // Optional: show error message to user
    //     } finally {
    //       setIsLoading(false); // Stop loader in finally block to ensure it always runs
    //     }
    //   };

    const username = async (value) => {
        const response = await UserRegUpdate(user_id, value);
        const user_filter = response.filter((i) => i.id === user_id);
        setData(user_filter);
        setPhone_pop(3);
        form.setFieldsValue(value);
    };

    const profile_details = async (value) => {
        setIsLoading(true); // Start loader
        try {
            //console.log(value, "****** value ********");
            //console.log(data, "**** Data *******");
            const d = new Date(value.dob),
                t = new Date();
            const age =
                t.getFullYear() -
                d.getFullYear() -
                (t < new Date(t.getFullYear(), d.getMonth(), d.getDate()));
            //console.log(age, "******* age *********");
            const gender = value.gender;
            const district = value.district;
            const state = value.state;
            const firstname = value.firstname;
            const caste = value.caste;
            const email = value.email;
            const contact1 = value.contact1;


            const contact = data.map((i) => i.contact);
            const refer = data.map((i) => i.refer);
            const user_name = data.map((i) => i.username);

            let refValu = ref ? ref : admin_id ? admin_id : "ref";

            // const user_update = {
            //   first_name: firstname,
            //   gender: gender,
            //   district: district,
            //   state: state,
            //   ref: refValu,
            //   caste: caste,
            //   contact: contact,
            // };

            const user_update = new FormData();

            user_update.append("first_name", firstname);
            user_update.append("gender", gender);
            user_update.append("district", district);
            user_update.append("state", state);
            user_update.append("ref", refValu);
            user_update.append("caste", caste);
            user_update.append("email", email);
            user_update.append("pic", file); // ✅ Add image here

            const formData = new FormData();
            formData.append("pic", file);
            formData.append("User_id", user_id);

            formData.append("contact", contact);
            formData.append("contact1", contact1);
            formData.append("email", email);

            formData.append("ref", refValu);
            formData.append("refer", refer);
            formData.append("username", user_name);
            formData.append("age", age);

            Object.entries(value).forEach(([key, val]) => {
                formData.append(key, val);
            });

            const response = await UserDataPostwt(formData);
            const response1 = await UserRegUpdate(user_id, user_update);

            if (response) {
                message.success("Registration Success");
                Navigate("/User_Login");
            }

            //console.log(user_update, "****** user_update *******");
        } catch (error) {
            //console.error("Error in profile_details:", error);
            message.error("Something went wrong. Please try again.");
        } finally {
            setIsLoading(false); // Stop loader
        }
    };

    return (
        <>


            {/* <Header /> */}
            <div
                style={{
                    backgroundImage:
                        "url('https://images.pexels.com/photos/5713682/pexels-photo-5713682.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2')",
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    minHeight: "100vh",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "start",
                    paddingTop: isMobile ? "100px" : "200px",
                }}
            >

                <div
                    style={{
                        width: isMobile ? "90%" : "1100px",
                        backgroundColor: "rgba(255, 255, 255, 0.95)",
                        padding: "30px",
                        borderRadius: "15px",
                        boxShadow: "0 4px 20px rgba(0,0,0,0.3)",
                        marginTop: isMobile ? "-150px" : "-100px",
                        marginTop: "5px",
                    }}
                >
                    <br /><br />
                    <div
                        style={{ textAlign: "center", marginBottom: 20, marginTop: "40px" }}
                    >
                        <h2>Signup Form</h2>
                    </div>

                    <Card>
                        {phone_pop === 0 && (
                            <Spin spinning={isLoading} tip="Sending OTP..." size="large">
                                <div
                                    style={{
                                        width: "90%",
                                        maxWidth: "800px",
                                        margin: "0 auto",
                                        padding: "24px", // Optional for spacing inside the form
                                        background: "#fff", // Optional: white background for better contrast
                                        borderRadius: "8px", // Optional: rounded corners
                                        boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)", // Optional: subtle shadow
                                    }}
                                >
                                    <Form onFinish={send}>
                                        <Form.Item
                                            name="contact"
                                            rules={[
                                                { required: true, message: "Please Enter your Mobile Number" },
                                                {
                                                    pattern: /^[0-9]{10}$/,
                                                    message: "Mobile number must be exactly 10 digits",
                                                },
                                            ]}
                                        >
                                            <Input
                                                type="tel"
                                                placeholder="Enter your Mobile Number"
                                                size="middle"
                                                inputMode="numeric"
                                                maxLength={10}
                                                disabled={isLoading}
                                                onChange={(e) => {
                                                    // remove non-digits and limit to 10
                                                    const value = e.target.value.replace(/\D/g, "").slice(0, 10);
                                                    e.target.value = value;
                                                }}
                                            />
                                        </Form.Item>

                                        <Form.Item style={{ textAlign: "center" }}>
                                            <Button
                                                htmlType="submit"
                                                size="middle"
                                                loading={isLoading}
                                                disabled={isLoading}
                                                style={{
                                                    width: "100%",
                                                    maxWidth: "120px",
                                                    color: "green",
                                                    border: "1px solid green",
                                                }}
                                            >
                                                Send
                                            </Button>
                                        </Form.Item>
                                    </Form>
                                </div>
                            </Spin>
                        )}

                        {/* OTP VERIFICATION */}
                        {/* {phone_pop === 1 && (
                            <div
                                style={{
                                    width: "90%",
                                    maxWidth: "800px",
                                    margin: "0 auto",
                                }}
                            >
                                <Form onFinish={verify} form={form} initialValues={form}>
                                    <Form.Item name="contact">
                                        <Input type="number" readOnly size="middle" />
                                    </Form.Item>
                                    <Form.Item name="otp">
                                        <Input type="number" placeholder="Enter OTP" size="middle" />
                                    </Form.Item>
                                    <Form.Item style={{ textAlign: "center" }}>
                                        <Button
                                            htmlType="submit"
                                            size="middle"
                                            style={{
                                                width: "100%",
                                                maxWidth: "120px",
                                            }}
                                        >
                                            Verify
                                        </Button>
                                    </Form.Item>
                                </Form>
                            </div>
                        )} */}

                        {/* USERNAME & PASSWORD */}
                        {phone_pop === 2 && (
                            <div
                                style={{
                                    width: "90%",
                                    maxWidth: "800px",
                                    margin: "0 auto",
                                }}
                            >
                                <Form onFinish={username} layout="vertical">
                                    <Form.Item
                                        label="Username"
                                        name="username"
                                        rules={[
                                            { required: true, message: "Please enter your username" },
                                            {
                                                min: 4,
                                                max: 16,
                                                message: "Username must be between 5 and 12 characters",
                                            },
                                            {
                                                validator: (_, value) =>
                                                    value && value.includes(" ")
                                                        ? Promise.reject(
                                                            "Spaces are not allowed in the username"
                                                        )
                                                        : Promise.resolve(),
                                            },
                                            {
                                                pattern: /^[a-z]+$/,
                                                message:
                                                    "Username must contain only lowercase letters (a-z)",
                                            },
                                        ]}
                                    >
                                        <Input placeholder="Enter your username" />
                                    </Form.Item>

                                    {/* --- UPDATED PASSWORD FIELD --- */}
                                    <Form.Item
                                        name="password"
                                        label="Password"
                                        rules={[
                                            {
                                                required: true,
                                                message: "Please create a password!",
                                            },
                                            {
                                                min: 8,
                                                message: "Password must be at least 8 characters long!",
                                            },
                                            {
                                                pattern: /[A-Z]/,
                                                message:
                                                    "Password must contain at least one uppercase letter.",
                                            },
                                            {
                                                pattern: /[a-z]/,
                                                message:
                                                    "Password must contain at least one lowercase letter.",
                                            },
                                            {
                                                pattern: /[0-9]/,
                                                message: "Password must contain at least one number.",
                                            },
                                        ]}
                                        extra="Must be at least 8 characters and include uppercase, lowercase, and a number."
                                        hasFeedback // This adds a green checkmark icon when validation passes
                                    >
                                        <Input.Password
                                            placeholder="Create your password"
                                            size="middle"
                                        />
                                    </Form.Item>
                                    {/* --- END OF UPDATE --- */}

                                    <Form.Item style={{ textAlign: "center", paddingTop: "10px" }}>
                                        <Button
                                            htmlType="submit"
                                            size="middle"
                                            style={{
                                                width: "100%",
                                                maxWidth: "120px",
                                            }}
                                        >
                                            Submit
                                        </Button>
                                    </Form.Item>
                                </Form>
                            </div>
                        )}

                        {/* FULL PROFILE FORM */}
                        {phone_pop === 3 && (
                            <Spin spinning={isLoading} tip="Saving profile..." size="large">
                                <Form
                                    form={form}
                                    onFinish={profile_details}
                                    initialValues={form}
                                    layout="vertical"
                                >
                                    <Row gutter={[16, 16]}>
                                        <Col span={24}>
                                            <Form.Item label="Profile Picture" required>
                                                <Upload
                                                    beforeUpload={(file) => {
                                                        setFile(file);
                                                        form.setFieldsValue({ pic: file.name });
                                                        return false;
                                                    }}
                                                    showUploadList={false}
                                                >
                                                    <Button icon={<UploadOutlined />} size="middle">
                                                        Choose File
                                                    </Button>
                                                </Upload>
                                                <Form.Item name="pic" noStyle>
                                                    <Input
                                                        style={{ marginTop: 8 }}
                                                        disabled
                                                        placeholder="No file selected"
                                                        size="middle"
                                                    />
                                                </Form.Item>
                                            </Form.Item>
                                        </Col>

                                        {[
                                            { name: "firstname", label: "Full Name" },
                                            {
                                                name: "gender",
                                                label: "Gender",
                                                type: "select",
                                                options: ["Male", "Female"],
                                            },
                                            // { name: "state", label: "State", type: "select", options: ["Chhattisgarh"], onChange: handleStateChange },
                                            {
                                                name: "state",
                                                label: "State",
                                                type: "select",
                                                options: [
                                                    "Andhra Pradesh",
                                                    "Arunachal Pradesh",
                                                    "Assam",
                                                    "Bihar",
                                                    "Chhattisgarh",
                                                    "Goa",
                                                    "Gujarat",
                                                    "Haryana",
                                                    "Himachal Pradesh",
                                                    "Jharkhand",
                                                    "Karnataka",
                                                    "Kerala",
                                                    "Madhya Pradesh",
                                                    "Maharashtra",
                                                    "Manipur",
                                                    "Meghalaya",
                                                    "Mizoram",
                                                    "Nagaland",
                                                    "Odisha",
                                                    "Punjab",
                                                    "Rajasthan",
                                                    "Sikkim",
                                                    "Tamil Nadu",
                                                    "Telangana",
                                                    "Tripura",
                                                    "Uttar Pradesh",
                                                    "Uttarakhand",
                                                    "West Bengal",
                                                ],
                                                onChange: handleStateChange,
                                            },
                                            {
                                                name: "district",
                                                label: "District",
                                                type: "select",
                                                dynamic: district?.[0],
                                            },
                                            { name: "city", label: "City" },
                                            {
                                                name: "religion",
                                                label: "Religion",
                                                type: "select",
                                                options: [
                                                    "Hindu",
                                                    "Muslim",
                                                    "Christian",
                                                    "Sikh",
                                                    "Buddhist",
                                                    "Jain",
                                                    "Other",
                                                ],
                                                onChange: handlereligionChange,
                                            },
                                            {
                                                name: "caste",
                                                label: "Caste",
                                                type: "select",
                                                dynamic: Array.isArray(caste[0]) ? caste[0] : caste,
                                                searchable: true,
                                            },
                                            {
                                                name: "subcaste",
                                                label: "Sub Caste",
                                                type: "subcaste",
                                            },
                                            { name: "dob", label: "DOB", type: "date" },
                                            // { name: "age", label: "Age", type: "number" },
                                            { name: "father_name", label: "Father's Name" },
                                            { name: "mother_name", label: "Mother's Name" },
                                            {
                                                name: "brother",
                                                label: "No. of Brothers",
                                                type: "tel",
                                                min: 0,
                                                defaultValue: 0,
                                            },
                                            {
                                                name: "brother_marrige",
                                                label: "Married Brothers",
                                                type: "tel",
                                                min: 0,
                                                defaultValue: 0,
                                            },
                                            { name: "sister", label: "No. of Sisters", type: "tel", defaultValue: 0, },
                                            {
                                                name: "sister_marrige",
                                                label: "Married Sisters",
                                                type: "tel",
                                                min: 0,
                                                defaultValue: 0,
                                            },
                                            { name: "university", label: "University" },
                                            { name: "course", label: "Course" },
                                            { name: "job_title", label: "Job Title" },
                                            { name: "Lifestyle", label: "Life Style" },

                                            {
                                                name: "job_type",
                                                label: "Job Type",
                                                type: "select",
                                                options: ["Govt", "Pvt"],
                                            },
                                            {
                                                name: "marrige_status",
                                                label: "Marriage Status",
                                                type: "select",
                                                options: ["Unmarried", "Divorced"],
                                                defaultValue: "Unmarried",
                                            },

                                            {
                                                name: "mother_tongue",
                                                label: "Mother Tongue",
                                                type: "select",
                                                options: [
                                                    "Hindi",
                                                    "English",
                                                    "Marathi",
                                                    "Punjabi",
                                                    "Gujarati",
                                                    "Bengali",
                                                    "Tamil",
                                                    "Telugu",
                                                    "Kannada",
                                                    "Malayalam",
                                                    "Odia",
                                                    "Assamese",
                                                    "Konkani",
                                                    "Manipuri",
                                                    "Kashmiri",
                                                    "Sanskrit",
                                                    "Santali",
                                                    "Dogri",
                                                    "Maithili",
                                                    "Sindhi",
                                                    "Bodo",
                                                    "Urdu",
                                                    "Nepali",
                                                    "Tulu",
                                                    "Other",
                                                ],
                                            },
                                            {
                                                name: "height",
                                                label: "Height",
                                                type: "select",
                                                options: generateHeightOptions(),
                                                searchable: true,
                                            },

                                            {
                                                name: "blood_group",
                                                label: "Blood Group",
                                                type: "select", // dropdown
                                                options: ["A+", "A-", "B+", "B-", "AB+", "AB-", "O+", "O-"]

                                            },

                                            { name: "salary", label: "Salary", type: "tel" },

                                            {
                                                name: "email",
                                                label: "email",
                                                type: "email",
                                                // placeholder: "Enter 10-digit number",
                                                // maxLength: 11,
                                                // onInput: (e) => {
                                                //   e.target.value = e.target.value
                                                //     .replace(/\D/g, "")
                                                //     .slice(0, 10);
                                                // },
                                            },
                                            {
                                                name: "contact1",
                                                label: "Mobile Number ( Optional )",
                                                type: "tel",
                                                placeholder: "Enter 10-digit mobile number",
                                                maxLength: 11,
                                                onInput: (e) => {
                                                    e.target.value = e.target.value
                                                        .replace(/\D/g, "")
                                                        .slice(0, 10);
                                                },
                                            },

                                            {
                                                name: "created_profile",
                                                label: "Created Profile",
                                                type: 'select',
                                                options: ["self", "son", "daughter", "sister", "friend", "other"]
                                            },

                                            // ------------------------ Maping code ----------------------------
                                        ].map((field) => (
                                            <Col key={field.name} xs={24} sm={12} md={12} lg={6}>
                                                <Form.Item name={field.name} label={field.label}>
                                                    {field.type === "select" ? (
                                                        <Select
                                                            showSearch={field.searchable}
                                                            allowClear
                                                            placeholder={field.label}
                                                            onChange={field.onChange}
                                                            size="middle"
                                                            optionFilterProp="children"
                                                            filterOption={(input, option) =>
                                                                option?.children
                                                                    ?.toLowerCase()
                                                                    .includes(input.toLowerCase())
                                                            }
                                                        >
                                                            {(field.dynamic || field.options || []).map(
                                                                (opt, i) => (
                                                                    <Option key={i} value={opt}>
                                                                        {opt}
                                                                    </Option>
                                                                )
                                                            )}
                                                        </Select>
                                                    ) : field.type === "date" ? (
                                                        <Input type="date" size="middle" />
                                                    ) : field.type === "textarea" ? (
                                                        <Input.TextArea
                                                            rows={field.rows}
                                                            cols={field.cols}
                                                            placeholder={field.label}
                                                        />
                                                    ) : (
                                                        <Input
                                                            type={field.type || "text"}
                                                            placeholder={field.placeholder || field.label}
                                                            maxLength={field.maxLength}
                                                            onInput={field.onInput}
                                                            size="middle"
                                                        />
                                                    )}
                                                </Form.Item>
                                            </Col>
                                        ))}

                                        <Col span={24}>
                                            <Form.Item>
                                                <Button type="primary" htmlType="submit" size="middle">
                                                    Save
                                                </Button>
                                            </Form.Item>
                                        </Col>
                                    </Row>
                                </Form>
                            </Spin>
                        )}
                    </Card>
                </div>
            </div>
        </>

    );
}

export default Registration_WO;
